import styled from 'styled-components'
import { BREAK_POINT_MD } from '@CSSVars/variables'
// import {
//   GREY_BACKGROUND,
// } from '@CSSVars/colors'


export const _Demographics = styled.div`
  h4 {
    margin-top: 24px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
  }
`

export const _ModalContainer = styled.div`
  background-color: white;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 100px;

  h4 {
    margin-top: 24px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
  }

  h3 {
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
  }
`

export const _CoreComponentsTitle = styled.h4`
  font-size: 20px !important;
  font-weight: 600;
  margin-bottom: 20px;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    font-size: 18px !important;
  }
`
